















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { officeService } from "@/services/office";
import { Office } from "@/swagger/models";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "OfficePicker",
})
export default class OfficePicker extends Vue {
    @Prop({ required: true })
    customerId: number;

    offices: Office[] = [];
    loading: boolean = false;

    @Watch("customerId", { immediate: true })
    async refreshOffices() {
        try {
            this.loading = true;
            this.offices = await officeService.find({
                params: { customer: this.customerId },
            });
        } catch (e) {
            console.warn(e);
        } finally {
            this.loading = false;
        }
    }
}
